const HEX = /^#[0-9a-f]{6}$/i
const color = (value, fallback) => HEX.test(value || '') ? value : fallback
export function normalizeRsAppearance(value, legacy = {}) {
  return Object.fromEntries(['light', 'dark'].map(theme => [theme, {
    labels: {
      dateLabelColor: color(value?.[theme]?.labels?.dateLabelColor, null),
      crosshairPriceLabelColor: color(value?.[theme]?.labels?.crosshairPriceLabelColor, null),
    },
    ...Object.fromEntries(['asset', 'benchmark'].map(role => {
      const entry = value?.[theme]?.[role] || {}
      const fallback = theme === 'dark' ? '#D1D5DB' : color(legacy?.[role], '#000000')
      return [role, {
        currentPriceLabelCustom: entry.currentPriceLabelCustom === true && HEX.test(entry.currentPriceLabelColor || ''),
        currentPriceLabelColor: color(entry.currentPriceLabelColor, fallback),
        lastPriceVisible: entry.lastPriceVisible !== false, color: color(entry.color, fallback), endColor: color(entry.endColor, theme === 'dark' ? '#B39DDB' : '#673AB7'),
        gradient: entry.gradient === 'price' ? entry.gradient : 'none',
        width: [1, 2, 3, 4].includes(entry.width) ? entry.width : 1,
        opacity: Number.isFinite(entry.opacity) ? Math.max(0, Math.min(100, entry.opacity)) : 100 }]
    })),
  }]))
}
export function lineColor(hex, opacity) {
  return `${hex}${Math.round(opacity * 255 / 100).toString(16).padStart(2, '0')}`
}
export function linePoints(bars, style) {
  if (style.gradient === 'none') return bars.map(bar => ({ time: bar.time, value: bar.close }))
  const values = bars.map(bar => bar.close)
  const low = values.reduce((min, value) => Math.min(min, value), Infinity)
  const high = values.reduce((max, value) => Math.max(max, value), -Infinity)
  return bars.map((bar, index) => {
    const weight = high > low ? (values[index] - low) / (high - low) : 0.5
    const hex = '#' + [1, 3, 5].map(offset => {
      const start = parseInt(style.color.slice(offset, offset + 2), 16), end = parseInt(style.endColor.slice(offset, offset + 2), 16)
      return Math.round(start + (end - start) * weight).toString(16).padStart(2, '0')
    }).join('')
    return { time: bar.time, value: bar.close, color: lineColor(hex, style.opacity) }
  })
}
